import React from 'react'
import { Dropdown as AntDropdown } from 'antd'
import { DropDownProps as AntDropdownProps } from 'antd/lib/dropdown'

type Props = AntDropdownProps

export const Dropdown: React.FC<Props> = ({
  children,
  arrow,
  overlay,
  overlayClassName,
  placement,
  disabled,
  trigger,
  onVisibleChange,
  visible,
  getPopupContainer
}) => {
  const otherProps = {
    ...(onVisibleChange !== undefined && { onVisibleChange }),
    ...(visible !== undefined && { visible })
  }
  return (
    <AntDropdown
      arrow={arrow}
      overlay={overlay}
      overlayClassName={overlayClassName}
      placement={placement}
      trigger={trigger}
      disabled={disabled}
      getPopupContainer={getPopupContainer}
      {...otherProps}
    >
      {children}
    </AntDropdown>
  )
}
